import { createClient } from '@supabase/supabase-js';

export const SUPABASE_URL = 'https://yhmjqfodxduwxsuknckp.supabase.co';
export const SUPABASE_ANON_KEY = 'sb_publishable_gUmbMyhXcJQMO_hw4ZEQdQ_XUf6BgUx';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

